import {
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React from 'react';
import EmailForm from './EmailForm';

const EmailFormModal = ({  showEmailModal, setShowEmailModal, emailsId, setEmails, emails, setIsLoading, emailToUpdate }) => {
    return (
      
            <MDBModal backdrop={false}  
                animationDirection='right'
                open={showEmailModal}
                staticBackdrop={true}
              
            >
                <MDBModalDialog  centered={true}>
                <MDBModalContent >
                    <MDBModalBody >
                        <EmailForm showEmailModal={showEmailModal} setShowEmailModal={setShowEmailModal} emailsId={emailsId} setEmails={setEmails} emails={emails} setIsLoading={setIsLoading} emailToUpdate={emailToUpdate}/>
                    </MDBModalBody>
                </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
     
    );
};

EmailFormModal.propTypes = {
    showEmailModal: PropTypes.bool.isRequired,
    setShowEmailModal: PropTypes.func.isRequired,
    emailsId: PropTypes.string,
    setEmails: PropTypes.func,
    emails: PropTypes.arrayOf(PropTypes.object),
    setIsLoading: PropTypes.func,
    emailToUpdate: PropTypes.object,
};

export default EmailFormModal;
